const Menu = [
    { header: 'Dashboard' },
    {
        name: 'dashboard',
        title: 'Invoices',
        icon: 'mdi-view-dashboard',
        path: '/invoices',
        group: 'dashboard'
    },

    {
        name: 'qr_codes',
        title: 'QR Codes',
        icon: 'mdi-qrcode',
        path: '/qr-codes',
        group: 'qr_codes'
    },

    {
        name: 'exports',
        title: 'Exports',
        icon: 'mdi-application-export',
        path: 'exports',
        group: 'exports'
    },
]

export { Menu }